(function () {
  'use strict';

  angular
    .module('ModalVdrivers', []);
}());
